import React, { FC } from 'react'
import { Box } from 'transfix-ui/core'
import { POINT_RADIUS, POINT_DIAMETER } from 'apps/tms/constants'

interface LegendItemProps {
  label: string
  color: string
}

export const LegendLabel: FC<LegendItemProps> = ({ color, label }) => (
  <Box display='flex' alignItems='center'>
    <svg width={POINT_DIAMETER} height={POINT_DIAMETER}>
      <circle cx={POINT_RADIUS} cy={POINT_RADIUS} r={POINT_RADIUS} fill={color} />
    </svg>
    <Box px={1}>{label}</Box>
  </Box>
)
